(function (angular) {
  'use strict';

  angular.module('app').component('stkFooter', {
    templateUrl: 'app/components/footer/footer.html'
  });
})(angular);
